var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOverviewCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#00CC99",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_784_4805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2916 30.1729V33.1708L21.5397 31.6718L19.2916 30.1729Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 25.3438C14.1143 25.3438 13.6666 25.7915 13.6666 26.3438V37C13.6666 37.5523 14.1143 38 14.6666 38H25.3229C25.8752 38 26.3229 37.5523 26.3229 37V26.3437C26.3229 25.7915 25.8752 25.3438 25.3229 25.3438H14.6666ZM19.4401 34.7615C18.7755 35.2045 17.8854 34.7281 17.8854 33.9295V29.4143C17.8854 28.6156 18.7755 28.1392 19.4401 28.5822L22.8266 30.8398C23.4204 31.2356 23.4204 32.1081 22.8266 32.5039L19.4401 34.7615Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8229 22.5312C28.2706 22.5312 27.8229 22.979 27.8229 23.5312V37C27.8229 37.5523 28.2706 38 28.8229 38H36.6666C37.2189 38 37.6666 37.5523 37.6666 37V23.5313C37.6666 22.979 37.2189 22.5312 36.6666 22.5312H28.8229ZM34.8541 34.4844C34.8541 34.8727 34.5393 35.1875 34.151 35.1875H31.3385C30.9502 35.1875 30.6354 34.8727 30.6354 34.4844C30.6354 34.0961 30.9502 33.7812 31.3385 33.7812H34.151C34.5393 33.7812 34.8541 34.0961 34.8541 34.4844ZM34.8541 31.6719C34.8541 32.0602 34.5393 32.375 34.151 32.375H31.3385C30.9502 32.375 30.6354 32.0602 30.6354 31.6719C30.6354 31.2836 30.9502 30.9688 31.3385 30.9688H34.151C34.5393 30.9688 34.8541 31.2836 34.8541 31.6719ZM34.8541 28.8594C34.8541 29.2477 34.5393 29.5625 34.151 29.5625H31.3385C30.9502 29.5625 30.6354 29.2477 30.6354 28.8594C30.6354 28.471 30.9502 28.1562 31.3385 28.1562H34.151C34.5393 28.1562 34.8541 28.471 34.8541 28.8594ZM34.8541 26.0469C34.8541 26.4352 34.5393 26.75 34.151 26.75H31.3385C30.9502 26.75 30.6354 26.4352 30.6354 26.0469C30.6354 25.6585 30.9502 25.3438 31.3385 25.3438H34.151C34.5393 25.3438 34.8541 25.6585 34.8541 26.0469Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1843 17.9297L18.5885 19.3339L21.401 16.5214L26.3229 21.4432V15C26.3229 14.4477 25.8752 14 25.3229 14H14.6666C14.1143 14 13.6666 14.4477 13.6666 15V21.4202L17.1843 17.9297Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.401 18.5098L18.5885 21.3223L17.1802 19.914L13.6666 23.4008V23.8436H26.3229V23.4316L21.401 18.5098Z",
    fill: "#00CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 20.0312C37.6666 20.5835 37.2189 21.0312 36.6666 21.0312H28.8229C28.2706 21.0312 27.8229 20.5835 27.8229 20.0312V15C27.8229 14.4477 28.2706 14 28.8229 14H36.6666C37.2189 14 37.6666 14.4477 37.6666 15V20.0312Z",
    fill: "#00CC99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_784_4805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13.6666 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverviewCampaign);
export default __webpack_public_path__ + "static/media/ICON_OVERVIEW_CAMPAIGN.68febaa34305a20f256655c685d98d3c.svg";
export { ForwardRef as ReactComponent };